"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var IAlwaysUpdateMatrix = (function (_super) {
    __extends(IAlwaysUpdateMatrix, _super);
    function IAlwaysUpdateMatrix() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IAlwaysUpdateMatrix;
}(zebra.data.Matrix));
exports.IAlwaysUpdateMatrix = IAlwaysUpdateMatrix;
exports.alwaysUpdateMatrix = zebra.Class(zebra.data.Matrix, [
    function (data, rows, cols) {
        this.$super(data, rows, cols);
    },
    function put(row, col, obj) {
        var nr = this.rows;
        var nc = this.cols;
        if (row >= nr) {
            nr += (row - nr + 1);
        }
        if (col >= nc) {
            nc += (col - nc + 1);
        }
        this.setRowsCols(nr, nc);
        if (obj !== undefined) {
            if (this.objs[row] == null) {
                this.objs[row] = [];
            }
            this.objs[row][col] = obj;
            this._.cellModified(this, row, col);
        }
    }
]);
//# sourceMappingURL=alwaysUpdateMatrix.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/grids/matrices/alwaysUpdateMatrix.js
// module id = 34
// module chunks = 0